<template>
    <div class="container">
        <div class="product row py-5">
            <div class="col-md-6">
                <image-slider v-if="item.images" :imgs="item.images"/>
                <img v-else :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview-large.jpg`)" class="img-fluid w-100">
            </div>
            <div class="col-md-6">
                <div class="product-info">
                    <div class="product-header">
                        <!--<span class="product-labels">
                            <template v-if="minVariant.photos_limit_from && minVariant.photos_limit_to">
                                {{ $tc('photo_box_limit', minVariant.photos_limit_to, {limit_from: minVariant.photos_limit_from, limit_to: minVariant.photos_limit_to}) }}
                            </template>
                            <template v-else-if="minVariant.photos_limit_from">
                                {{ $tc('from_n_photos', minVariant.photos_limit_from, {amount: minVariant.photos_limit_from}) }}
                            </template>
                            <template v-else-if="minVariant.photos_limit_to">
                                {{ $tc('until_n_photos', minVariant.photos_limit_to, {amount: minVariant.photos_limit_to}) }}
                            </template>
                            <small class="float-right">{{ $t(item.variants.length === 1 ? 'piece' : 'from') }}</small>
                        </span>-->
                        <span class="product-titles">
                            {{ item.name }}
                            <!--<small>
                                {{ minVariant.price | currency }}
                            </small>-->
                        </span>
                    </div>
                    <div class="product-body" v-if="item.description" v-html="item.description"></div>
                    <!--<div v-if="variants && variants.length > 1 || currentBulkPrices && currentBulkPrices.length > 1" class="row mt-4">
                        <div class="col-md-7" v-if="variants && variants.length > 1">
                            <div class="form-group">
                                <label for="variants">{{ $t('variants') }}</label>
                                <select id="variants" class="custom-select" v-model="variant">
                                    <option v-for="(item, i) in variants" :key="i" :value="item">
                                        {{ item.name }} - {{ item.price | currency }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-7" v-if="currentBulkPrices && currentBulkPrices.length > 1">
                            <div class="form-group mb-0">
                                <label for="bulk-price">{{ $t('select_bulk_price') }}</label>
                                <select id="bulk-price" class="custom-select" v-model="currentBulkPrice">
                                    <option :value="null" selected>{{ $t('not_selected') }}</option>
                                    <option v-for="(item, i) in currentBulkPrices" :key="i" :value="item">
                                        {{ $tc('from_n_pieces', item.quantity, {amount: item.quantity}) }} - {{ item.price_gross | currency }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>-->
                    <a href="#" @click.prevent="selectProduct" id="nextStepBtn" class="btn btn-success btn-icon-left btn-shadow text-uppercase">
                        <span class="material-icon" :class="isMobile ? 'icon-check' : 'icon-add'"/>
                        <template v-if="!isMobile">
                            {{ $t('select_product') }}
                        </template>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .product {

        &-header {
            margin-top: 60px;
        }

        &-info {
            padding-left: 20px;

            @media (max-width: 768px) {
                padding-left: 0;
            }
        }

        &-labels,
        &-titles {
            display: block;
            line-height: 1;

            &:after {
                content: '';
                display: table;
                clear: both;
            }
        }

        &-labels {
            margin-bottom: 15px;
            font-size: 1.5rem;
            color: var(--text-secondary-color);
        }

        &-titles {
            position: relative;
            font-size: 3rem;
            padding-right: 150px;
            color: var(--text-color);

            small {
                position: absolute;
                top: 0;
                right: 0;
                font-weight: 500;
            }
        }

        &-body {
            margin-top: 40px;
            margin-bottom: 15px;
            font-size: 1rem;
            color: var(--text-secondary-color);
            line-height: 1.8;
        }

        .btn {
            margin-top: 30px;
        }

        img {
            width: 100%;
            height: auto;
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>

<script>
  import imageSlider from '../ImageSlider';

  import orderStep3DefaultConfirm from 'src/mixins/orderStep3DefaultConfirmComponent';

  export default {
    mixins: [orderStep3DefaultConfirm],
    components: {
      imageSlider,
    },
  };
</script>
